import axios from 'axios';
import config from '../config';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
});

// Interceptor para agregar token a todas las requests (excepto login)
api.interceptors.request.use(
  (configAxios) => {
    // Evitar logs de token en el endpoint de login
    if (configAxios.url === '/login') {
      return configAxios;
    }
    const token = localStorage.getItem(config.tokenKey);
    if (token) {
      configAxios.headers.Authorization = `Bearer ${token}`;
      console.log('🔐 Token agregado al header');
    } else {
      // No hay token antes de iniciar sesión; no es un error
      // Evitamos el log ruidoso para no confundir durante el login
    }
    return configAxios;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    // No manejar 401 en el endpoint de login (credenciales inválidas)
    if (status === 401 && url === '/login') {
      console.warn('⚠️ Credenciales inválidas');
      return Promise.reject(error);
    }

    // Para otros endpoints, si hay 401, limpiar sesión
    if (status === 401) {
      console.error('❌ Token expirado o inválido');
      localStorage.removeItem(config.tokenKey);
      localStorage.removeItem(config.userKey);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
